import gql from 'graphql-tag'

export const CreateSupplier = gql`
    mutation CreateSupplier($input: CreateSupplierInput!, $condition: ModelSupplierConditionInput) {
        createSupplier(input: $input, condition: $condition) {
            bankAccount
            companyName
            primaryContactEmail
            primaryContactName
            secondaryContactEmail
            secondaryContactName
            supplierId
        }
    }
`

export const UpdateSupplier = gql`
    mutation UpdateSupplierDetails($input: UpdateSupplierDetailsInput!) {
        updateSupplierDetails(input: $input) {
            address
            bankAccount
            companyName
            lastLoggedIn
            primaryContactEmail
            primaryContactName
            secondaryContactEmail
            secondaryContactName
            status
            supplierId
            vatRegNumber
        }
    }
`

export const UpdateSupplierTransaction = gql`
    mutation UpdateTransactionDetails($input: UpdateTransactionDetailsInput!) {
        updateTransactionDetails(input: $input) {
            userId
            transactionId
            transactionSupplierId
            resourceId
            price
            priceDescription
            ApiIntegration
            state
            title
            address
            deliveryTrackingNumber
            deliveryCompany
            deliveryEstimatedDuration
            dateOfConfirmation
            sku
            updatedAt
            autoPayed
            availability
            showType
            date
            productId
            invoiceUrl
            note
            pillars
            pilotTag
            retailer
            supplierIdAirtable
            type
            voucherCode
            voucherId
        }
    }
`

export const GetSupplier = gql`
    query GetSupplierDetails($supplierId: ID!, $userType: String) {
        getSupplierDetails(supplierId: $supplierId, userType: $userType) {
            bankAccount
            companyName
            tradingName
            vatRegNumber
            companyRegNumber
            address
            financeEmail
            financePhone
            primaryContactPhone
            accountsPayableEmail
            lastLoggedIn
            primaryContactEmail
            primaryContactName
            secondaryContactEmail
            secondaryContactName
            status
            supplierId
        }
    }
`

export const GetSupplierTransactionsAndResources = gql`
    query GetSupplierDetails(
        $supplierId: ID!
        $nextTokenT: String
        $nextTokenR: String
        $userType: String
    ) {
        getSupplierDetails(supplierId: $supplierId, userType: $userType) {
            bankAccount
            companyName
            createdAt
            lastLoggedIn
            monthlyBreakdown
            primaryContactEmail
            primaryContactName
            secondaryContactEmail
            secondaryContactName
            supplierId
            totalPaidAmount
            transactionsAvgMonthly
            transactionsCancelled
            transactionsConfirmed
            transactionsPending
            transactionsTotal
            updatedAt
            tradingName
            vatRegNumber
            companyRegNumber
            address
            financeEmail
            financePhone
            primaryContactPhone
            accountsPayableEmail
            transactions(nextToken: $nextTokenT) {
                items {
                    address
                    ApiIntegration
                    autoPayed
                    automationType
                    date
                    dateOfConfirmation
                    deliveryCompany
                    deliveryEstimatedDuration
                    deliveryTrackingNumber
                    invoiceUrl
                    note
                    pillars
                    pilotTag
                    price
                    priceDescription
                    productId
                    receiveDonationEmails
                    resourceId
                    retailer
                    showType
                    sku
                    state
                    supplierIdAirtable
                    title
                    transactionId
                    transactionSupplierId
                    type
                    updatedAt
                    userId
                    voucherCode
                    voucherId
                }
                nextToken
            }
            resources(limit: 500, nextToken: $nextTokenR) {
                items {
                    resourceId
                    description
                    oneliner
                    title
                    updatedAt
                    age
                    algorithmTags
                    availability
                    availabilityDescription
                    automationType
                    confirmationTextFree
                    confirmationTextPaidDigital
                    confirmationTextPaidProduct
                    dateOfLastUpdate
                    deliveryMethod
                    digital
                    free
                    icon
                    iconOriginal
                    image
                    imageHero
                    imageOriginal
                    imageThumbL
                    imageThumbS
                    liveForPilots
                    newToPilots
                    pillars
                    productsV2
                    type
                    visibleWebsite
                    website
                    websiteOther
                    websiteSchedule
                }
                nextToken
            }
        }
    }
`
